export const BG_Url = 'https://assets.nflxext.com/ffe/siteui/vlv3/20bf1f4d-1c73-48fd-8689-310d6dd80efc/304b7563-abfe-41bf-95d0-8bb58c03bea6/US-en-20240812-POP_SIGNUP_TWO_WEEKS-perspective_WEB_633da30f-4247-4a0f-b146-0501cbf91542_large.jpg';
export const Logo_Url = 'Screenshot 2024-09-10 115658.png';
export const Photo_Url = 'https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png';
export const API_options = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhNTZmOTJjZTJmYzQzZDVhMTRlOGU0NWQ4MjZhNTEwOSIsIm5iZiI6MTczMTA1MDQ2MC43NzIxNTE1LCJzdWIiOiI2NmQxOGU4OGE3OWRkYzVmYWM0NTU1YTgiLCJzY29wZXMiOlsiYXBpX3JlYWQiXSwidmVyc2lvbiI6MX0.r34K7B8q3zBOiu6RkQ6b6ktYdZH_gupR9Vu9uuV0MPg" ,
    },
};
export const POSTER_CDN_URL = 'https://image.tmdb.org/t/p/w500/';
export const AI_KEY = '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';
